<div class="container mt-4" style="min-height: calc(100vh - 300px);">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <h5 class="font-medium election-title">📄 Audit Fees MPR</h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <form [formGroup]="targetForm" (ngSubmit)="getAuditFeesMPR()">
                            <div class="row align-items-end">
                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="this.UserDetails?.roleId == 1">
                                    <label class="form-label">Circle Office <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="circleOffice" (change)="GetBlock()">
                                        <option value="">--Select--</option>
                                        <option *ngFor="let circle of circlesList" [value]="circle?.iCircleId">
                                            {{ circle?.sCircleName }}
                                        </option>
                                    </select>
                                    <div *ngIf="targetForm.get('circleOffice')?.touched && targetForm.get('circleOffice')?.invalid"
                                        class="text-danger small">
                                        Circle office is required
                                    </div>
                                </div>

                                <!-- Block Office -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Block Office <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="blockOffice">
                                        <option value="" selected>--Select--</option>
                                        <option *ngFor="let block of blockList" [value]="block?.iBlockId">
                                            {{ block?.sBlockName }}
                                        </option>
                                    </select>
                                    <div *ngIf="targetForm.get('blockOffice')?.touched && targetForm.get('blockOffice')?.invalid"
                                        class="text-danger small">
                                        block Office is required
                                    </div>
                                </div>

                                <!-- Financial Year -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Financial/Reporting Year <span
                                            class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="financialYear">
                                        <option value="">--Select--</option>
                                        <option *ngFor="let years of financialYears" [ngValue]="years?.financialYear">
                                            {{ years?.financialYear }}
                                        </option>
                                    </select>
                                    <div *ngIf="targetForm.get('financialYear')?.touched && targetForm.get('financialYear')?.invalid"
                                        class="text-danger small">
                                        Financial year is required
                                    </div>
                                </div>

                                <!-- Submit -->
                                <div class="col-lg-12 text-end">
                                    <button type="submit" class="btn btn-primary" [disabled]="targetForm.invalid">
                                        Get Report
                                    </button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <div class="d-flex align-items-center justify-content-between">
                        <h5 class="font-medium m-0">📄Report</h5>
                        <button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal"
                            data-bs-target="#addAuditFeeMPRModal" (click)="addData()"
                            *ngIf="showButton && (this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13)">+ Add
                            Audit Fees MPR {{currentMonth?.name}}</button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>S.No.</th>
                                    <th>Month</th>
                                    <th>Auditor Type</th>
                                    <th>Audit Fee Assessed</th>
                                    <th>Audit Fee Recovered</th>
                                    <th>Total No. of Audit Conducted</th>
                                    <th>Balance of Audit Fee</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                
                                <ng-container *ngFor="let group of groupedTableData">
                                    <tr *ngFor="let item of group.items; let i = index">
                                        <!-- ✅ Merge S.No and Month only once -->
                                        <td *ngIf="i === 0" [attr.rowspan]="group.items.length">{{ group.sno }}</td>
                                        <td *ngIf="i === 0" [attr.rowspan]="group.items.length">{{ group.month }}</td>

                                        <td>{{ item.auditorType }}</td>
                                        <td>{{ item.auditFeesAssessed | number }}</td>
                                        <td>{{ item.auditFeesRecovered | number }}</td>
                                        <td>{{ item.totalAuditConducted }}</td>
                                        <td>{{ item.balanceAuditFees | number }}</td>
                                        <td>
                                            <div class="d-flex align-items-center gap-1" *ngIf="i === 0"
                                                [attr.rowspan]="group.items.length">
                                                <ng-container
                                                    *ngIf="!group.isVerified && this.UserDetails?.roleId !==1; else verifiedBlock">
                                                    <button type="button" class="btn btn-primary btn-sm"
                                                        title="Click to Edit" (click)="editRow(group)">
                                                        <i class="bi bi-pencil-square"></i>
                                                    </button>
                                                    <button type="button" class="btn btn-success btn-sm"
                                                        title="Click to Verify" *ngIf="this.UserDetails?.roleId ==13"
                                                        data-bs-toggle="modal" data-bs-target="#verifyConfirmModal"
                                                        (click)="setDeleteIndex(group)">
                                                        <i class="bi bi-clipboard2-check"></i>
                                                    </button>
                                                    <button type="button" class="btn btn-danger btn-sm"
                                                        title="Click to Delete" data-bs-toggle="modal"
                                                        data-bs-target="#deleteConfirmModal"
                                                        (click)="setDeleteIndex(group)">
                                                        <i class="bi bi-trash3"></i>
                                                    </button>
                                                    
                                                </ng-container>

                                                <!-- Verified State -->
                                                <ng-template #verifiedBlock>
                                                    <button type="button" class="btn btn-primary btn-sm">
                                                        <i class="bi bi-lock"></i>
                                                    </button>
                                                </ng-template>
                                            </div>

                                        </td>


                                        <!-- <td *ngIf="i === 0" [attr.rowspan]="group.items.length">
                                            <div class="d-flex align-items-center gap-2">
                                                <button type="button" class="btn btn-primary btn-sm"
                                                    title="View Report">
                                                    <i class="bi bi-eye-fill"></i>
                                                </button>
                                                <button type="button" class="btn btn-warning btn-sm"
                                                    title="Verify Report">
                                                    <i class="bi bi-clipboard2-check"></i>
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm"
                                                    title="Delete Report">
                                                    <i class="bi bi-trash3"></i>
                                                </button>
                                            </div>
                                        </td> -->
                                    </tr>
                                </ng-container>
                                
                            </tbody>

                            
                        </table>




                        <!-- Delete Confirmation Modal -->
                        <div class="modal fade" id="deleteConfirmModal" tabindex="-1"
                            aria-labelledby="deleteConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Delete</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to delete ?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                            (click)="cancelDelete()">Cancel</button>
                                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                                            aria-label="Close" (click)="deleteAuditFeesMPR(deleteIndex)">Delete</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- verify Confirmation Modal -->
                        <div class="modal fade" id="verifyConfirmModal" tabindex="-1"
                            aria-labelledby="verifyConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Veriication</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to Verify?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                            (click)="this.deleteIndex = 0;">Cancel</button>
                                        <button type="button" class="btn btn-success" data-bs-dismiss="modal"
                                            aria-label="Close" (click)="verifyAuditFeesMPR(deleteIndex)">Verify</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


                <!-- Modal -->
                <div class="modal fade" id="addAuditFeeMPRModal" data-bs-backdrop="static" data-bs-keyboard="false"
                    tabindex="-1" aria-labelledby="addAuditFeeMPRModal" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl ">
                        <div class="modal-content">
                            <div class="modal-header">
                                <!-- <h1 class="modal-title fs-5" id="addAuditFeeMPRModal">Add Audit Conducted
                                </h1> -->
                                <div class="col-lg-12">
                                    <h4 class="font-medium">📊 Audit Fee MPR</h4>
                                </div>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModel()"
                                    aria-label="Close"></button>
                            </div>
                            <div class="modal-body">

                                <form [formGroup]="auditFeeForm" (ngSubmit)="onSubmit()">
                                    <div class="container mt-4" style="min-height: calc(100vh - 300px)">
                                        <div class="row">
                                            <!-- Total Conducted -->
                                            <div class="col-lg-3 col-md-6 mb-3">
                                                <label class="form-label">
                                                    Total No. of Audit Conducted up to Date <sup
                                                        class="text-danger">*</sup>
                                                </label>
                                                <input type="text" formControlName="tAuditConductedUptoDate"
                                                    class="form-control" placeholder="Please Enter" maxlength="10"
                                                    (keypress)="onlyNumbers($event)" />
                                                <div *ngIf="f['tAuditConductedUptoDate'].touched && f['tAuditConductedUptoDate'].invalid"
                                                    class="text-danger">
                                                    Field is required and must be numeric
                                                </div>
                                            </div>

                                            <!-- Departmental Auditor -->
                                            <div class="col-lg-12">
                                                <div class="card">
                                                    <div class="card-header">
                                                        <h5 class="font-medium m-0">📄 Departmental Auditor</h5>
                                                    </div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-lg-3 mb-2">
                                                                <label class="form-label">Audit Fee Assessed <sup
                                                                        class="text-danger">*</sup></label>
                                                                <input type="text" formControlName="dAuditFeesAssessed"
                                                                    class="form-control" placeholder="Please Enter"
                                                                    maxlength="10" (keypress)="onlyNumbers($event)" />
                                                                <div *ngIf="f['dAuditFeesAssessed'].touched && f['dAuditFeesAssessed'].invalid"
                                                                    class="text-danger">
                                                                    Field is required and must be numeric
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-3 mb-2">
                                                                <label class="form-label">Audit Fee Recovered <sup
                                                                        class="text-danger">*</sup></label>
                                                                <input type="text" formControlName="dAuditFeesRecovered"
                                                                    class="form-control" placeholder="Please Enter"
                                                                    maxlength="10" (keypress)="onlyNumbers($event)" />
                                                                <div *ngIf="f['dAuditFeesRecovered'].touched && f['dAuditFeesRecovered'].invalid"
                                                                    class="text-danger">
                                                                    Field is required and must be numeric
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-3 mb-2">
                                                                <label class="form-label">Total No. of Audit Conducted
                                                                    <sup class="text-danger">*</sup></label>
                                                                <input type="text" formControlName="dtAuditConducted"
                                                                    class="form-control" placeholder="Please Enter"
                                                                    maxlength="10" (keypress)="onlyNumbers($event)" />
                                                                <div *ngIf="f['dtAuditConducted'].touched && f['dtAuditConducted'].invalid"
                                                                    class="text-danger">
                                                                    Field is required and must be numeric
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-3 mb-2">
                                                                <label class="form-label">Balance of Audit Fee <sup
                                                                        class="text-danger">*</sup></label>
                                                                <input type="text" formControlName="dAuditFeesBalance"
                                                                    class="form-control" placeholder="Please Enter"
                                                                    maxlength="10" (keypress)="onlyNumbers($event)" />
                                                                <div *ngIf="f['dAuditFeesBalance'].touched && f['dAuditFeesBalance'].invalid"
                                                                    class="text-danger">
                                                                    Field is required and must be numeric
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Certified Auditor -->
                                            <div class="col-lg-12">
                                                <div class="card">
                                                    <div class="card-header">
                                                        <h5 class="font-medium m-0">📄 Certified Auditor</h5>
                                                    </div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-lg-3 mb-2">
                                                                <label class="form-label">Audit Fee Assessed <sup
                                                                        class="text-danger">*</sup></label>
                                                                <input type="text" formControlName="cAuditFeesAssessed"
                                                                    class="form-control" placeholder="Please Enter"
                                                                    maxlength="10" (keypress)="onlyNumbers($event)" />
                                                                <div *ngIf="f['cAuditFeesAssessed'].touched && f['cAuditFeesAssessed'].invalid"
                                                                    class="text-danger">
                                                                    Field is required and must be numeric
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-3 mb-2">
                                                                <label class="form-label">Audit Fee Recovered <sup
                                                                        class="text-danger">*</sup></label>
                                                                <input type="text" formControlName="cAuditFeesRecovered"
                                                                    class="form-control" placeholder="Please Enter"
                                                                    maxlength="10" (keypress)="onlyNumbers($event)" />
                                                                <div *ngIf="f['cAuditFeesRecovered'].touched && f['cAuditFeesRecovered'].invalid"
                                                                    class="text-danger">
                                                                    Field is required and must be numeric
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-3 mb-2">
                                                                <label class="form-label">Total No. of Audit Conducted
                                                                    <sup class="text-danger">*</sup></label>
                                                                <input type="text" formControlName="ctAuditConducted"
                                                                    class="form-control" placeholder="Please Enter"
                                                                    maxlength="10" (keypress)="onlyNumbers($event)" />
                                                                <div *ngIf="f['ctAuditConducted'].touched && f['ctAuditConducted'].invalid"
                                                                    class="text-danger">
                                                                    Field is required and must be numeric
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-3 mb-2">
                                                                <label class="form-label">Balance of Audit Fee <sup
                                                                        class="text-danger">*</sup></label>
                                                                <input type="text" formControlName="cAuditFeesBalance"
                                                                    class="form-control" placeholder="Please Enter"
                                                                    maxlength="10" (keypress)="onlyNumbers($event)" />
                                                                <div *ngIf="f['cAuditFeesBalance'].touched && f['cAuditFeesBalance'].invalid"
                                                                    class="text-danger">
                                                                    Field is required and must be numeric
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Chartered Accountant -->
                                            <div class="col-lg-12">
                                                <div class="card">
                                                    <div class="card-header">
                                                        <h5 class="font-medium m-0">📄 Chartered Accountant</h5>
                                                    </div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-lg-3 mb-2">
                                                                <label class="form-label">Audit Fee Assessed <sup
                                                                        class="text-danger">*</sup></label>
                                                                <input type="text" formControlName="caAuditFeesAssessed"
                                                                    class="form-control" placeholder="Please Enter"
                                                                    maxlength="10" (keypress)="onlyNumbers($event)" />
                                                                <div *ngIf="f['caAuditFeesAssessed'].touched && f['caAuditFeesAssessed'].invalid"
                                                                    class="text-danger">
                                                                    Field is required and must be numeric
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-3 mb-2">
                                                                <label class="form-label">Audit Fee Recovered <sup
                                                                        class="text-danger">*</sup></label>
                                                                <input type="text"
                                                                    formControlName="caAuditFeesRecovered"
                                                                    class="form-control" placeholder="Please Enter"
                                                                    maxlength="10" (keypress)="onlyNumbers($event)" />
                                                                <div *ngIf="f['caAuditFeesRecovered'].touched && f['caAuditFeesRecovered'].invalid"
                                                                    class="text-danger">
                                                                    Field is required and must be numeric
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-3 mb-2">
                                                                <label class="form-label">Total No. of Audit Conducted
                                                                    <sup class="text-danger">*</sup></label>
                                                                <input type="text" formControlName="catAuditConducted"
                                                                    class="form-control" placeholder="Please Enter"
                                                                    maxlength="10" (keypress)="onlyNumbers($event)" />
                                                                <div *ngIf="f['catAuditConducted'].touched && f['catAuditConducted'].invalid"
                                                                    class="text-danger">
                                                                    Field is required and must be numeric
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-3 mb-2">
                                                                <label class="form-label">Balance of Audit Fee <sup
                                                                        class="text-danger">*</sup></label>
                                                                <input type="text" formControlName="caAuditFeesBalance"
                                                                    class="form-control" placeholder="Please Enter"
                                                                    maxlength="10" (keypress)="onlyNumbers($event)" />
                                                                <div *ngIf="f['caAuditFeesBalance'].touched && f['caAuditFeesBalance'].invalid"
                                                                    class="text-danger">
                                                                    Field is required and must be numeric
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Retiree Auditor -->
                                            <div class="col-lg-12">
                                                <div class="card">
                                                    <div class="card-header">
                                                        <h5 class="font-medium m-0">📄 Retiree Auditor</h5>
                                                    </div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-lg-3 mb-2">
                                                                <label class="form-label">Audit Fee Assessed <sup
                                                                        class="text-danger">*</sup></label>
                                                                <input type="text" formControlName="rAuditFeesAssessed"
                                                                    class="form-control" placeholder="Please Enter"
                                                                    maxlength="10" (keypress)="onlyNumbers($event)" />
                                                                <div *ngIf="f['rAuditFeesAssessed'].touched && f['rAuditFeesAssessed'].invalid"
                                                                    class="text-danger">
                                                                    Field is required and must be numeric
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-3 mb-2">
                                                                <label class="form-label">Audit Fee Recovered <sup
                                                                        class="text-danger">*</sup></label>
                                                                <input type="text" formControlName="rAuditFeesRecovered"
                                                                    class="form-control" placeholder="Please Enter"
                                                                    maxlength="10" (keypress)="onlyNumbers($event)" />
                                                                <div *ngIf="f['rAuditFeesRecovered'].touched && f['rAuditFeesRecovered'].invalid"
                                                                    class="text-danger">
                                                                    Field is required and must be numeric
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-3 mb-2">
                                                                <label class="form-label">Total No. of Audit Conducted
                                                                    <sup class="text-danger">*</sup></label>
                                                                <input type="text" formControlName="rtAuditConducted"
                                                                    class="form-control" placeholder="Please Enter"
                                                                    maxlength="10" (keypress)="onlyNumbers($event)" />
                                                                <div *ngIf="f['rtAuditConducted'].touched && f['rtAuditConducted'].invalid"
                                                                    class="text-danger">
                                                                    Field is required and must be numeric
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-3 mb-2">
                                                                <label class="form-label">Balance of Audit Fee <sup
                                                                        class="text-danger">*</sup></label>
                                                                <input type="text" formControlName="rAuditFeesBalance"
                                                                    class="form-control" placeholder="Please Enter"
                                                                    maxlength="10" (keypress)="onlyNumbers($event)" />
                                                                <div *ngIf="f['rAuditFeesBalance'].touched && f['rAuditFeesBalance'].invalid"
                                                                    class="text-danger">
                                                                    Field is required and must be numeric
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Submit Button -->
                                            <!-- <div class="col-lg-12 text-end mt-3">
                                                <button type="submit" class="btn btn-primary">Submit</button>
                                            </div> -->
                                        </div>
                                    </div>
                                </form>




                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                    (click)="closeModel()">Close</button>
                                <!-- <button type="button" class="btn btn-primary" (click)="onSubmit()">Save</button> -->
                                <!-- Submit Button -->
                                <!-- <div class="col-lg-12 text-end mb-4"> -->
                                <button type="submit" class="btn btn-primary" (click)="onSubmit()">Save</button>
                                <!-- </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>